import { Events } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AreaAdminLocalProvider } from '../area-admin-local/area-admin-local'
import { AreaLocalProvider } from '../area-local/area-local';
import { BrComService } from '../../service/BrComService';
import { EmpresaLocalProvider } from '../empresa-local/empresa-local';
import { HttpServidor } from '../shared/abstract/http-servidor';
import { Mensagem, OrigemMensagem, ArquivoMensagem } from '../../models/mensagem';
import { MensagemProvider } from '../mensagem/mensagem';
import { ConversaUsaurio } from '../../models/area';

@Injectable()
export class AreaProvider extends HttpServidor {

  constructor(http: HttpClient,
    private areaLocalProvider: AreaLocalProvider,
    private areaAdminLocalProvider: AreaAdminLocalProvider,
    private mensagemProvider: MensagemProvider,
    private empresaLocal: EmpresaLocalProvider,
    private brComService: BrComService,
    private events: Events) {
    super(http);
  }

  public getMensagensAntigasArea(idArea: number, idUsuario: number, idUltimaMensagem: number): Observable<Mensagem[]> {
    const form = new FormData();
    form.append('id_area', String(idArea));
    form.append('id_usuario', String(idUsuario))
    form.append('id_envio_mais_antigo', String(idUltimaMensagem));
    return this.post('obtemMensagensAntigasArea', form);
  };

  public enviarMensagemSimplesAdminArea(idUsuarioOrigem: number, idArea: number, idDevice: number, mensagem: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('mensagem', mensagem);
    return this.post('enviaMensagemSimplesAdminArea', form);
  }

  public enviarMensagemSimplesUsuarioArea(idUsuarioOrigem: number, idArea: number, idDevice: number, mensagem: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('mensagem', mensagem);
    return this.post('enviaMensagemSimplesUsuarioArea', form);
  }

  public enviarMensagemSimplesResposta(idUsuarioOrigem: number, idUsuarioDestino: number, idArea: number, idDevice: number, mensagem: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', JSON.stringify(idUsuarioOrigem));
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_area', JSON.stringify(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('mensagem', mensagem);
    return this.post('enviaMensagemSimplesResposta', form);
  }

  public enviarMensagemImagemAdminArea(idUsuarioOrigem: number, idArea: number, idDevice: number, link: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('link', link);
    return this.post('enviaMensagemImagemAdminArea', form);
  }

  public enviarMensagemImagemUsuarioArea(idUsuarioOrigem: number, idArea: number, idDevice: number, link: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('link', link);
    return this.post('enviaMensagemImagemUsuarioArea', form);
  }

  public enviarMensagemImagemResposta(idUsuarioOrigem: number, idUsuarioDestino: number, idArea: number, idDevice: number, link: string): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', JSON.stringify(idUsuarioOrigem));
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_area', JSON.stringify(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('link', link);
    return this.post('enviaMensagemImagemResposta', form);
  }

  public enviarMensagemArquivoAdminArea(idUsuarioOrigem: number, idArea: number, idDevice: number, arquivo: ArquivoMensagem): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('arquivo', JSON.stringify(arquivo));
    return this.post('enviaMensagemArquivoAdminArea', form);
  }

  public enviarMensagemArquivoUsuarioArea(idUsuarioOrigem: number, idArea: number, idDevice: number, arquivo: ArquivoMensagem): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', String(idUsuarioOrigem));
    form.append('id_area', String(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('arquivo', JSON.stringify(arquivo));
    return this.post('enviaMensagemArquivoUsuarioArea', form);
  }

  public enviarMensagemArquivoResposta(idUsuarioOrigem: number, idUsuarioDestino: number, idArea: number, idDevice: number, arquivo: ArquivoMensagem): Observable<number> {
    const form = new FormData();
    form.append('id_usuario_origem', JSON.stringify(idUsuarioOrigem));
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_area', JSON.stringify(idArea));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('arquivo', JSON.stringify(arquivo));
    return this.post('enviaMensagemArquivoResposta', form);
  }

  public notificarMensagensLidas(idUsuario: number, idDevice: number, idArea: number): Observable<void> {
    const form = new FormData();
    form.append('id_usuario', JSON.stringify(idUsuario));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('registraMensagensAreaLidas', form);
  }

  public notificarMensagensAreaAdminLidas(idUsuarioOrigem: number, idUsuarioDestino: number, idDevice: number, idArea: number): Observable<void> {
    const form = new FormData();
    form.append('id_usuario_origem', JSON.stringify(idUsuarioOrigem));
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('registraMensagensAreaAdminLidas', form);
  }

  public notificarMensagensAreaAdminGeralLidas(idUsuarioDestino: number, idDevice: number, idArea: number): Observable<void> {
    const form = new FormData();
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('registraMensagensAreaAdminGeralLidas', form);
  }

  public notificarMensagensRecebidas(idUsuario: number, idDevice: number, idArea: number): Observable<void> {
    const form = new FormData();
    form.append('id_usuario', JSON.stringify(idUsuario));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('registraMensagensAreaRecebidas', form);
  }

  public notificarMensagensAreaAdminRecebidas(idUsuarioOrigem: number, idUsuarioDestino: number, idDevice: number, idArea: number): Observable<void> {
    const form = new FormData();
    form.append('id_usuario_origem', JSON.stringify(idUsuarioOrigem));
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('registraMensagensAreaAdminRecebidas', form);
  }


  public notificarMensagensAreaAdminGeralRecebidas(idUsuarioDestino: number, idDevice: number, idArea: number): Observable<void> {
    const form = new FormData();
    form.append('id_usuario_destino', JSON.stringify(idUsuarioDestino));
    form.append('id_device', JSON.stringify(idDevice));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('registraMensagensAreaAdminGeralRecebidas', form);
  }

  public getConversaUsuario(idUsuario: number, idArea: number): Observable<ConversaUsaurio> {
    const form = new FormData();
    form.append('id_usuario', JSON.stringify(idUsuario));
    form.append('id_area', JSON.stringify(idArea));
    return this.post('obtemConversaUsuario', form);
  }

  public processarMensagemSimples(payload: any): void {
    const mensagem = this.mensagemProvider.criarMensagemSimples(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemResposta(payload: any): void {
    const mensagem = this.mensagemProvider.criarMensagemResposta(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemImagem(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemImagem(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemLink(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemLink(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemFacebook(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemFacebook(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemArquivo(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemArquivo(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarMensagemHTML(payload): void {
    const mensagem = this.mensagemProvider.criarMensagemHTML(payload);
    this.adicionarNovaMensagem(mensagem);
  }

  public processarSincronizacaoLeitura(payload): void {
    if (this.areaAdminLocalProvider.hasArea(payload.idArea)) {
      if (payload.idUsuarioOrigem) {
        this.areaAdminLocalProvider.marcarMensagensLidas(payload.idArea, payload.idUsuarioOrigem);
      } else {
        this.areaAdminLocalProvider.marcarMensagensGeraisLidas(payload.idArea);
      }
    } else {
      this.areaLocalProvider.marcarMensagensLidas(payload.idArea, this.empresaLocal.getIdUsuario());
    }
  }

  private adicionarNovaMensagemArea(mensagem: Mensagem, idUsuario: number) {
    mensagem.origem = OrigemMensagem.ESQUERDA;
    this.areaLocalProvider.adicionarNovaMensagem(mensagem.idArea, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}`, mensagem);
    this.notificarMensagensRecebidas(idUsuario, this.brComService.getIdDevice(), mensagem.idArea).subscribe(
      () => {
        this.areaLocalProvider.marcarMensagemRecebida(mensagem.idArea, mensagem.idEnvio);
      }
    );
  }

  private adicionarNovaMensagemAreaAdmin(mensagem: Mensagem, idUsuarioDestino: number) {
    mensagem.origem = OrigemMensagem.ESQUERDA;
    this.areaAdminLocalProvider.adicionarNovaMensagem(mensagem.idArea, mensagem.idUsuarioOrigem, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}.${mensagem.idUsuarioOrigem}`, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}.geral`, mensagem);
    this.notificarMensagensAreaAdminRecebidas(mensagem.idUsuarioOrigem, idUsuarioDestino, this.brComService.getIdDevice(), mensagem.idArea).subscribe(
      () => {
        this.areaAdminLocalProvider.marcarMensagemRecebida(mensagem);
      }
    );
  }

  private adicionarNovaMensagemAreaAdminGeral(mensagem: Mensagem) {
    mensagem.origem = OrigemMensagem.ESQUERDA;
    this.areaAdminLocalProvider.adicionarNovaMensagemGeral(mensagem.idArea, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}.geral`, mensagem);
    this.notificarMensagensAreaAdminGeralRecebidas(mensagem.idUsuarioDestino, this.brComService.getIdDevice(), mensagem.idArea).subscribe(
      () => {
        this.areaAdminLocalProvider.marcarMensagemGeralRecebida(mensagem);
      }
    );
  }

  private adicionarNovaMensagemEnviadaDeOutroDevice(mensagem: Mensagem): void {
    mensagem.origem = OrigemMensagem.DIREITA;
    mensagem.podeSerRespondida = false;
    this.areaLocalProvider.adicionarNovaMensagem(mensagem.idArea, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}`, mensagem);
  }

  private adicionarNovaMensagemEnviadaDeOutroDeviceAdmin(mensagem: Mensagem): void {
    mensagem.origem = OrigemMensagem.DIREITA;
    this.areaAdminLocalProvider.adicionarNovaMensagem(mensagem.idArea, mensagem.idUsuarioDestino, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}.${mensagem.idUsuarioDestino}`, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}.geral`, mensagem);
  }

  // enviada para todos os usuários
  private adicionarNovaMensagemEnviadaDeOutroDeviceAdminGeral(mensagem: Mensagem): void {
    mensagem.origem = OrigemMensagem.DIREITA;
    this.areaAdminLocalProvider.adicionarNovaMensagemGeral(mensagem.idArea, mensagem);
    this.events.publish(`msg.area.${mensagem.idArea}.geral`, mensagem);
    const area = this.areaAdminLocalProvider.getArea(mensagem.idArea);
    if (area) {
      for (const c of area.conversasUsuarios) {
        this.events.publish(`msg.area.${mensagem.idArea}.${c.idUsuario}`, mensagem);
      }
    }
  }

  private adicionarNovaMensagem(mensagem: Mensagem) {
    if (this.areaAdminLocalProvider.hasArea(mensagem.idArea)) {
      this.adicionarMensagemAreaAdmin(mensagem);
    } else {
      this.adicionarMensagemAreaComum(mensagem);
    }
  }

  private adicionarMensagemAreaAdmin(mensagem: Mensagem): void {
    // ideia: colocar na mensagem marcadores como origemSistema e mensagem geral
    // é mais resistente a alterações futuras
    if (!mensagem.idUsuarioOrigem) {
      // mensagem do sistema
      this.adicionarNovaMensagemAreaAdminGeral(mensagem);
    } else {
      const administradores = this.areaAdminLocalProvider.getArea(mensagem.idArea).idAdministradores || [];
      if (administradores.indexOf(mensagem.idUsuarioOrigem) > -1) {
        this.adicionarMensagemAreaAdminSincronizacao(mensagem);
      } else {
        this.adicionarMensagemAreaAdmnRecebida(mensagem);
      }
    }
  }

  private adicionarMensagemAreaAdminSincronizacao(mensagem: Mensagem) {
    const idUsuario = this.empresaLocal.getEmpresa().IdUsuario;
    // mensagem enviada de um admin para um usuario
    if (mensagem.idUsuarioDestino) {
      const conversaUsuario = this.areaAdminLocalProvider.getConversaUsuario(mensagem.idArea, mensagem.idUsuarioDestino);
      if (conversaUsuario) {
        this.adicionarNovaMensagemEnviadaDeOutroDeviceAdmin(mensagem);
      } else {
        this.adicionarNovaMensagemEnviadaDeOutroDeviceAdminGeral(mensagem);
        // busca nova conversa no servidor;
        this.adicionarConversaUsuario(idUsuario, mensagem.idArea);
      }
    } else {
      // mensagem enviada de um admin para todos os usuários
      this.adicionarNovaMensagemEnviadaDeOutroDeviceAdminGeral(mensagem);
    }
  }

  private adicionarMensagemAreaAdmnRecebida(mensagem: Mensagem) {
    const idUsuario = this.empresaLocal.getEmpresa().IdUsuario;
    const conversaUsuario = this.areaAdminLocalProvider.getConversaUsuario(mensagem.idArea, mensagem.idUsuarioOrigem);
    if (conversaUsuario) {
      // recebeu uma nova mensagem
      this.adicionarNovaMensagemAreaAdmin(mensagem, idUsuario);
    } else {
      this.adicionarNovaMensagemAreaAdminGeral(mensagem);
      // busca nova conversa no servidor;
      this.adicionarConversaUsuario(mensagem.idUsuarioOrigem, mensagem.idArea);
    }
  }

  private adicionarMensagemAreaComum(mensagem: Mensagem): void {
    const idUsuario = this.empresaLocal.getEmpresa().IdUsuario;
    if (mensagem.idUsuarioOrigem === idUsuario) {
      // mensagem de sincronização enviada de um usuário comum para admin
      this.adicionarNovaMensagemEnviadaDeOutroDevice(mensagem);
    } else {
      // mensagem de um admin ou do sistema para um usuário
      this.adicionarNovaMensagemArea(mensagem, idUsuario);
    }
  }

  private adicionarConversaUsuario(idUsuario: number, idArea: number) {
    this.getConversaUsuario(idUsuario, idArea).subscribe(
      conversaUsuario => {
        this.areaAdminLocalProvider.adicionarConversaUsuario(idArea, conversaUsuario);
      }
    )
  }
}


// WEBPACK FOOTER //
// ./src/providers/area/area.ts